import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: "text"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "30",
                height: "30",
                rx: "15",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M23 8H7C5.34315 8 4 9.34315 4 11V17H18V18H4V19C4 20.6569 5.34315 22 7 22H21V13H7V12H21V10C21.5523 10 22 10.4477 22 11V22H23C24.6569 22 26 20.6569 26 19V11C26 9.34315 24.6569 8 23 8Z",
                fill: "#030014"
            })
        ]
    }));
};
export default Icon;
